import { gql } from '@apollo/client'

import { SIMPLE_ACTION_GENERATOR_FRAGMENT } from '../fragments/SimpleActionGeneratorFragment'

export const GET_ACTION_GENERATORS_SIMPLE = gql`
  query GetActionGeneratorsSimple(
    $filters: ActionGeneratorFilter!
    $pagination: OffsetPaginationInput
  ) {
    tenantActionGenerators(filters: $filters, pagination: $pagination) {
      results {
        ...SimpleActionGeneratorFragment
      }
      totalCount
    }
  }
  ${SIMPLE_ACTION_GENERATOR_FRAGMENT}
`
